// extracted by mini-css-extract-plugin
export default {"board-wrapper":"BoardManager-module__board-wrapper___RYyT1"};